<script>
        import {onMount} from 'svelte'
        import {locale, language } from '../../languages'
        import Progress from '../../components/Progress.svelte'
        import Select from '../../components/Select.svelte'
        import {getResourceById,getResource,updateResource } from '../../service'            
        import routerManager from '../../router/router'
        import * as yup from 'yup'
        import {Notyf} from 'notyf'




        const router = routerManager.getRouter('default')
        let station
        let step = 0;
        let resp;
        let governorate                
        let formData = {
            "no":null,
            "area_id" : null,
            "model" : null,
            "transformers_no" : 0,
            "address" : null,
            "address_no" : null,
            "ownership_type" : null,
            "status":null

        }
        let transformers_no_options = [0,2,4,6,8]
        let ownership_types = ['حكومي','خاص']
        let status_options = ['تعمل','لا تعمل','قيد الإنشاء','موقع فقط','قيد الصيانة']

        

        let schemas = {
            0:  yup.object().shape({
                area: yup.object()
                        .shape({
                            name:yup.string().required(),
                            id:yup.number().required()
                        }),
                no:yup.string().required(),
                model : yup.string().required(),
                transformers_no: yup.number().required()
                }),
            1: yup.object().shape({
                address : yup.string().required(),
                // address_no : yup.string().matches(/\d/,{excludeEmptyString:true}).nullable(),
                latitude :   yup.string().matches(/\d/,{excludeEmptyString:true}),
                longitude :  yup.string().matches(/\d/,{excludeEmptyString:true}),

                }),
            2: yup.object().shape({
                ownership_type: yup.string().required(),
                status:yup.string().required()
            })    

        }
        
        function getLocation(){

            if('geolocation' in navigator){
                navigator.geolocation.getCurrentPosition((position) => {
                  
                  formData.latitude = position.coords.latitude
                  formData.longitude = position.coords.longitude
                });
            }else {
                console.log('no geolocation found')
            }
        }   

        function applyData(data){        
            if(data == null || typeof(data) == 'undefined') return
            let columns = ["no","area","area_id","address","address_no","model","transformers_no",
                            "ownership_type","status","contractor_id","latitude","longitude"]
            columns.forEach(c => {
                let val = data[c] 
                
                if(val){
                    
                    formData[c] = val
                }
            })   
            formData.address_no = data['address_no'] || ''      
           
            console.log(formData)    

        }

        onMount(()=>{
            let params = router.getState().params                   
            
            getResourceById('stations',params.station_id)
            .subscribe(p=>{
                p.then(data=>{                    
                    station = data
                    getResourceById('governorates',data.area.governorate_id)
                    .subscribe(p=>{
                        p.then(gov => {
                            
                            governorate = gov
                            applyData(data)
                        })
                    })
                })
            })

            resp = getResource('governorates')            

        })

        
        $: schema  = schemas[step]
        let errors = {}

        function extractErrors(err) {
            return err.inner.reduce((acc, err) => {               
            return { ...acc, [err.path]: err.message };
            }, {});
        }

        function nextStep(){
            console.log('next step ')
            
            if(step < 2){
                
                schema.validate(formData,{abortEarly:false})
                .then(()=>{                    
                        errors = {}                     
                        step++;
                        
                    
                }).catch(err=>{                  
                    errors = extractErrors(err)                  
                })
            }
        }

        function prevStep(){
            if(step > 0 ){
                step--;
            }
        }
        const notify = new Notyf({duration:2000,position:{x:'center',y:'top'}})                    

        function submit(){            
            formData.area_id = formData.area.id 
            
            // delete formData.area            
                        
            updateResource('stations',station.id,formData)            
            .subscribe(p => {
                p.then(resp => {
                    notify.success('تمت العملية بنجاح')
                    
                    router.navigate("detail",{station_id:resp.id,station:resp})                      
                }).catch(err => {
                    // formData.area = station.area
                    notify.error({
                        duration:4000,dismissible:true,
                        message:"فشل عملية الحفظ"
                    })
                })
            })
            

        }
    
    $: areas = governorate?governorate.areas:[]    
</script>
<style>
    .step {
        width:100%;
        min-height: 70vh;
    }
    .has-errors {
        color:#d55;        
    }

    input.has-errors ,div.has-errors {
        border:solid thick #da8;
    }

</style>
<div class="w-full  h-full flex flex-col justify-center">
    {#await $resp}
        <div class="flex flex-row justify-center">
            <Progress size={100} class=" text-green-400 m-20" />
        </div>
        {:then governorates} 
        <div class="flex flex-row justify-center p-2">
            <h1 class="text-lg font-bold">{$language.label_add_station}</h1>
        </div>
        <div class="flex flex-row justify-center">
            <form on:submit|preventDefault={submit} 
                class=" border-2 w-full md:w-6/12">
                <div class="step flex flex-col p-4 gap-4">
                    {#if step == 0}
                        <label for="">{$language.label_governorate} :</label>                 
                        <div class="rounded-full border-2 border-green-400 px-4">
                             <Select items={governorates} bind:selected={governorate}
                                class=" w-full p-1  bg-white focus:outline-none" 
                                labelKey={$locale=='ar'?'name':'name_en'}/>                            
                        </div>
                        <label for="" class:has-errors={errors.area}>
                            <span>{$language.label_area} :</span>
                            
                        </label>                 
                        <div  class:has-errors={errors.area} class="rounded-full border-2 border-green-400 px-4">                            
                            <Select items={governorate?governorate.areas:[]}
                                bind:selected={formData.area} labelKey={$locale=='ar'?'name':'name_en'}
                                class=" w-full p-1  bg-white focus:outline-none" />                                                  
                        </div>
                        <label for="" class:has-errors={errors.no}>{$language.label_station_no}</label>
                        <input type="text" class:has-errors={errors.no} bind:value={formData.no}  class="w-full p-1 rounded-full border-2 border-green-400">
                        <label for="" class:has-errors={errors.model}>{$language.label_station_model}</label>
                        <input type="text" class:has-errors={errors.model} bind:value={formData.model} class="w-full p-1 rounded-full border-2 border-green-400">
                        <label for="" class:has-errors={errors.transformers_no} >{$language.label_station_transNo}</label>
                        <div class:has-errors={errors.transformers_no} class="rounded-full border-2 border-green-400 px-4">
                            <Select items={transformers_no_options} bind:selected={formData.transformers_no} isList={true}
                               class=" w-full p-1  bg-white focus:outline-none"/>
                        </div>
                    {/if}
                    {#if step == 1}
                        <label for="" class:has-errors={errors.address}>{$language.label_station_address }</label>
                        <input type="text" class:has-errors={errors.address} bind:value={formData.address} class="w-full p-1 rounded-full border-2 border-green-400">
                        <label for="" class:has-errors={errors.address_no}>{$language.label_station_addressNo }</label>
                        <input type="text" class:has-errors={errors.address_no} bind:value={formData.address_no} class="w-full p-1 rounded-full border-2 border-green-400">
                        <hr>
                        <div class="flex flex-col gap-2">
                            
                            <label for="" class:has-errors={errors.latitude} >{$language.label_latitude }</label>
                            <input type="text" class:has-errors={errors.latitude} bind:value={formData.latitude} class="w-full p-1 rounded-full border-2 border-green-400">
                            <label for="" class:has-errors={errors.longitude} >{$language.label_longitude }</label>
                            <input type="text" class:has-errors={errors.longitude} bind:value={formData.longitude} class="w-full p-1 rounded-full border-2 border-green-400">
                        </div>
                        <div class="flex flex-row justify-center">                        
                            <button class="text-sm bg-green-400 text-white p-4 rounded-full" on:click|preventDefault={getLocation}>{$language.btn_get_location}</button>
                        </div>
                    {/if}
                    {#if step == 2}
                        <label for="" class:has-errors={errors.ownership_type}>{$language.label_station_ownership_type }</label>
                         <div class:has-errors={errors.ownership_type} class="rounded-full border-2 border-green-400 px-4">
                            <Select items={ownership_types} bind:selected={formData.ownership_type} isList={true}
                               class=" w-full p-1  bg-white focus:outline-none"/>
                        </div>
                        <label for="" class:has-errors={errors.status}>{$language.label_station_status }</label>
                         <div class:has-errors={errors.status} class="rounded-full border-2 border-green-400 px-4">
                            <Select items={status_options} bind:selected={formData.status} 
                               class=" w-full p-1  bg-white focus:outline-none"/>
                        </div>
                    {/if}
                    
                </div>
                <div class="flex flex-row gap-2 mx-2">
                    {#if step > 0 }
                        <button class="w-full my-2  p-2 bg-green-400 text-white" on:click|preventDefault={prevStep}>
                             {$language.btn_prev}
                        </button>
                    {/if}
                    {#if step < 2}
                        <button class="w-full my-2  p-2 bg-green-400 text-white" on:click|preventDefault={nextStep}>
                             {$language.btn_next }
                        </button>
                    {/if}
                    {#if step == 2}
                        <button type="submit" class="w-full my-2  p-2 bg-green-400 text-white">
                            {$language.btn_save}
                        </button>
                    {/if}
                </div>
            </form>
        </div>
        {/await}

</div>